import axios from '@/http/axios/index.js'

export default {
    getUsers(payload) {
        return axios.get('notifications/recruitment/users', { params: payload })
    },
    getNotifications() {
        return axios.get('notifications/recruitment/get_notifications',)
    },
    updateUser(payload) {
        return axios.post('notifications/recruitment/users/update', payload )
    },
}
